import KardiaRxCCTPatients from './KardiaRxCCTPatients';

export default KardiaRxCCTPatients;



// WEBPACK FOOTER //
// ./src/views/pages/KardiaRxCCTPatients/index.js